import PERMISSIONS from '@/constants/permissions';
import { hasPermission } from '@/utils/permission';

/**
 * 路由 / 按钮权限
 */
export default function access(
    initialState: { currentUser?: API.CurrentUser; isSuperAdmin?: boolean } | undefined,
) {
    const { currentUser, isSuperAdmin = false } = initialState ?? {};
    const permissions = currentUser?.permissions || [];
    const superAdmin = isSuperAdmin || currentUser?.isSuperAdmin || false;

    const checkMenuPermission = (permissionCode: string | string[]): boolean => {
        if (superAdmin) {
            return true;
        }
        return hasPermission(permissionCode, permissions);
    };

    const map: Record<string, boolean> = {};
    Object.values(PERMISSIONS).forEach((val) => {
        map[val] = checkMenuPermission(val);
    });

    return {
        ...map,
        canAdmin: !!currentUser,
        checkMenuPermission,
        hasPermission: (permissionCode: string | string[]) => {
            if (superAdmin) {
                return true;
            }
            return hasPermission(permissionCode, permissions);
        },
    };
}
